import { Component, OnInit,OnDestroy } from '@angular/core';
import { ServerService } from '../services/server.service';
import * as Feather from 'feather-icons';
import { Router,ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { v4 as uuidv4 } from 'uuid';
import Swal from 'sweetalert2'
declare var $: any;
declare var tinymce: any;
declare var iziToast: any;
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit,OnDestroy {
  cur: any = {};
  curdate;
  countryflagdata: any = "";
  userperms: any = [];
  pn: any = [];
  newseventsmodallist: any = [];

  notifydata: any = [];
  datas: any;
  headernoti_count: any = 0;
  loads = false;
  show_allowed_my_ip = false;
  profile;

  // jira modal-email
  createinformation: FormGroup;
  countryList: any;
  priorityList: any;
  supportRequestTypeList: any;
  files: any = [];
  filesend: any = [];
  customerdetails: any = {};
  datadetails: any;
  customer_contact:any;
  customer_mobilePhone:any;
  customer_customerPhone:any;
  user_email: string;
  customer_id;
  refreshInterval: any;
  ticketNotifications: any[] = [];
  shownNotificationIds: { [key: string]: boolean } = {};
  constructor(private router: Router, private http: HttpClient, private route: ActivatedRoute, public serverService: ServerService) {
    this.serverService.createticket.subscribe( (val:any) => 
    {
          console.log(val);
          this.createticket(val);
    })
    this.currencyview()
    this.countryflag()
    this.permissions()


  }

  ngOnInit(): void {
    this.customer_id = atob(localStorage.getItem('en'));
    console.log(this.customer_id);
    
    this.serverService.cn = localStorage.getItem('cn');
    this.user_email = localStorage.getItem('user_login_email')
    this.serverService.prof_img = localStorage.getItem('prof_img');
    var profiles = localStorage.getItem('profile_image');
    if (profiles != '' && profiles != null && profiles != undefined && profiles != 'undefined' && profiles != 'null') {
      this.profile = "https://erp.cal4care.com/cms_new/api_cms/v1.0/profile_image/" + profiles;
    }
    // this.notificationlist()
    this.createinformation = new FormGroup({
      'fromticket': new FormControl(null,
        Validators.required),
      // 'department': new FormControl(null),
      'country': new FormControl(null, Validators.required),
      'priority': new FormControl(null, Validators.required),
      'requestType': new FormControl(null, Validators.required),
      'subject': new FormControl(null, Validators.required),
      'messages': new FormControl(null)

    });
    this.jiraDropdown();
    this.countryflag1();
    this.initTiny();
    this.refreshInterval = setInterval(() => {
      this.ticketNotification();
    }, 2000);
  }

  reads(val) {


    console.log(val)
    if (val.type == "referral")
      this.router.navigate(['/referral']);
    if (val.type == "payment_add")
      this.router.navigate(['/buy3cx']);
    if (val.type == "renewal")
      this.router.navigate(['/renewal']);
    if (val.type == "invoice")
      this.router.navigate(['/invoice']);
    if (val.type == "payment_made")
      this.router.navigate(['/buy3cx']);
    if (val.type == "support")
      this.router.navigate(['/support-ticket']);

  }
  fullScreenBtn() {
    $("body").toggleClass("sidebar-mini");
  }

  read(val) {
    this.updatenotify(val)

  }
  logoutapp() {
    // localStorage.removeItem("access_token");
    // localStorage.removeItem("user_name");
    // localStorage.removeItem("user_type");
    // localStorage.clear();
    // this.router.navigate(['/logout']);
  }
  updatenotification() {

  }
  setvalue() {
    // $('#full-width-modal').modal('show');
    let datas: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');


    datas.action = "notification_list";
    datas.customer_id = customer_id;


    datasend.access_token = access_token;
    datasend.operation = "curlDatas";
    datasend.moduleType = "notification";
    datasend.api_type = "web";
    datasend.element_data = datas;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      console.log(response)
      if (response.status == "true") {
        // Swal.close()
        this.serverService.notifycount = response.count;

        // localStorage.setItem('nt', btoa(response.count));

      }
      else {
        // Swal.close()
        this.notifydata = [];

      }

    },
      (error) => {
        console.log(error);
      });

  }


  openmodal() {
    $('#addNewPopups').modal('show');
  }
  ngOnDestroy() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }
  ngAfterViewInit() {
    Feather.replace();
  }


  gooldcms() {
    this.loads = true;
    setTimeout(() => {

      let customer_id: any = localStorage.getItem('en');
      this.datas = uuidv4();
      var cust_id = btoa(customer_id)
      this.loads = false;
      // var sendurl ='https://cmsdev1.cal4care.com/cms_old/loginProcess_old_conv.php?Aghwj=M'+cust_id+'=&bmVrb3Q='+this.datas+'';
      var sendurl = 'https://erp.cal4care.com/cms_old/loginProcess_old_conv.php?Aghwj=M' + cust_id + '=&bmVrb3Q=' + this.datas + '';

      // var sendurl ='https://erp.cal4care.com/cms_old/loginProcess_old_conv.php?Aghwj=M'+cust_id+'=&bmVrb3Q='+this.datas+'';
      console.log(sendurl)
      // https://erp.cal4care.com/cms_new/cms_data_redirect.php?action=login_finger_chk&customer_email='+this.emailid+''
      window.open(sendurl, "_self");

    }, 2000);

  }


  currencyview() {

    let data: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');


    data.action = "currency_view";
    datasend.access_token = access_token;
    datasend.operation = "curlDatas";
    datasend.moduleType = "login";
    datasend.api_type = "web";
    datasend.element_data = data;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      console.log(response)
      if (response.status == "true") {
        this.cur = response.currency_array_values;
        this.curdate = response.curr_date;
        console.log(this.cur.SGD)
      }
      else {

      }
    },
      (error) => {
        console.log(error);
      });

  }


ticketNotification(): void {

  const access_token = localStorage.getItem('at') || '';
  const customer_id = localStorage.getItem('en') || '';

  const datas = {
    action: 'helpdesk_ticketnotification',
    customer_id: customer_id
  };

  const datasend = {
    access_token: access_token,
    moduleType: 'ticket',
    operation: 'helpDeskCurl',
    api_type: 'web',
    element_data: datas
  };

  this.http.post(
    'https://erp.cal4care.com/cms_new/api_cms/v1.0/index.php',
    datasend
  ).subscribe({

    next: (response: any) => {
      if (response?.result?.status !== true) {
        return;
      }
      const notifications =
        response?.result?.data?.notifications || [];
      this.ticketNotifications = notifications;
      if (!notifications.length) {
        return;
      }
      // Latest notification
      const notification = notifications[0];

      // commentId is unique
      const notificationId =
        notification.commentId ||
        (
          String(notification.ticketNumber) +
          '_' +
          String(notification.createdAt)
        );

      // Don't show the same notification again
      if (this.shownNotificationIds[notificationId]) {
        return;
      }

      this.shownNotificationIds[notificationId] = true;

      this.showTicketNotification(notification);
    },

    error: (error: any) => {

      console.error(
        'Ticket Notification API Error:',
        error
      );

    }

  });
}
showTicketNotification(notification: any): void {

  const ticketNumber = notification.ticketNumber;

  if (!ticketNumber) {
    return;
  }

  const ticketSubject =
    notification.ticketSubject || 'Ticket Notification';

  const authorName =
    notification.authorName || '';

  let message =
    (notification.body || '')
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  const maxLength = 100;

  if (message.length > maxLength) {
    message = message.substring(0, maxLength).trim() + '...';
  }

  const encodedTicketId = btoa(String(ticketNumber));

  const notificationUrl =
    'https://erp.cal4care.com/cms_new/#/support-ticket-list-thread?id=' +
    encodedTicketId;


  iziToast.show({
    icon: 'fas fa-ticket-alt',
    message: `
      <div class="ticket-toast-content">
        <div class="ticket-toast-title">
          <strong>Ticket Notification </strong> [#${ticketNumber}]
        </div>
        <div class="ticket-toast-message">
          <span class="ticket-toast-author">
            ${authorName}
          </span>,
          ${message}
        </div>
      </div>
    `,
    position: 'topRight',
    width: '400px',
    timeout: 10000,
    close: true,
    progressBar: true,
    backgroundColor: '#1769aa',
    titleColor: '#ffffff',
    messageColor: '#ffffff',
    iconColor: '#ffffff',
    progressBarColor: '#20c997',
    closeColor: '#ffffff',
    class: 'ticket-custom-toast',
    buttons: [
      [
        '<button class="ticket-open-btn">Open Ticket</button>',
        (instance: any, toast: any) => {
          window.location.href = notificationUrl;
        },
        true
      ],
      [
        '<button class="ticket-close-btn">Close</button>',
        (instance: any, toast: any) => {
          instance.hide({
            transitionOut: 'fadeOut'
          }, toast);
        }
      ]
    ]
  });

}





  countryflag() {

    let data: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');


    data.action = "contact_flag";
    data.customer_id = customer_id;
    data.customer_state = localStorage.getItem('customer_state');
    data.cms_user_id = localStorage.getItem('cms_user_id');

    datasend.access_token = access_token;
    datasend.operation = "curlDatas";
    datasend.moduleType = "login";
    datasend.api_type = "web";

    datasend.element_data = data;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      console.log(response)
      if (response.status == "true") {
        this.countryflagdata = response.cms_menu_data;
        // this.permscallhistory = response.customer_details;
      }
      else {

      }
    },
      (error) => {
        console.log(error);
      });

  }



  permissions() {
    this.pn = [];
    this.userperms = [];

    // this.serverService.invoice=0;
    // this.serverService.prepaidnote=0;
    // this.serverService.creditnote = 0;
    // this.serverService.license = 0;
    // this.serverService.projects = 0;
    // this.serverService.phones =0;
    // this.serverService.leads =0;
    // this.serverService.reseller =0;
    // this.serverService.callhistory =0;
    // this.serverService.cxbuy =0;
    // this.serverService.iddpricelist =0;
    // this.serverService.call4tellicense =0;
    // this.serverService.supportticket =0;
    // this.serverService.users =0;
    // this.serverService.callbalance =0;
    // this.serverService.users =0;
    // this.serverService.referral =0;
    // this.serverService.licencerenewal =0;
    // this.serverService.dealregistration =0;
    // this.serverService.callhistorypbx ="0";
    // this.serverService.callhistoryvspbx ="0";
    // this.serverService.gccfirewall =0;
    // this.serverService.notifycount =0;
    // this.serverService.callhistoryvspbx ="0";

    // public callbalance =0;
    // public referral =0;
    // public licencerenewal =0;
    // public dealregistration =0;
    // public callhistorypbx ="0";
    // public callhistoryvspbx ="0";
    // public gccfirewall = 0;
    // public notifycount = 0;
    // public invoice = 0;
    // public prepaidnote = 0;
    // public creditnote = 0;
    // public license = 0;
    // public projects = 0;
    // public phones =0;
    // public leads =0;
    // public reseller =0;
    // public callhistory =0;
    // public cxbuy =0;
    // public iddpricelist =0;
    // public call4tellicense =0;
    // public supportticket =0;
    // public users =0;
    // public callbalance =0;
    // public referral =0;
    // public licencerenewal =0;
    // public dealregistration =0;
    // public callhistorypbx ="0";
    // public callhistoryvspbx ="0";
    // public gccfirewall = 0;
    // public notifycount = 0;








    let data: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');


    data.action = "contact_flag";
    data.customer_id = customer_id;
    data.customer_state = localStorage.getItem('customer_state');
    data.cms_user_id = localStorage.getItem('cms_user_id');

    datasend.access_token = access_token;
    datasend.operation = "curlDatas";
    datasend.moduleType = "login";
    datasend.api_type = "web";

    datasend.element_data = data;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      console.log(response)
      if (response.status == "true") {
        // this.countryflagdata = response.cms_menu_data;
        // this.userperms = localStorage.getItem('pn').split(',')
        //   for (var i = 0; i < this.userperms.length; i++) {
        //   this.pn.push(atob(this.userperms[i]))
        // }
        this.serverService.callhistorypbx = response.customer_details.cms_username_dispaly;
        this.serverService.callhistoryvspbx = response.customer_details.cms_vs_pbx_dispaly;
        this.customer_customerPhone = response.customer_details.customerPhone;
        this.customer_mobilePhone =response.customer_details.mobilePhone;
        if(response.customer_details.customerPhone=='' || response.customer_details.customerPhone=='undefined' || response.customer_details.customerPhone==undefined){
          this.customer_contact=this.customer_mobilePhone;
        }else{
          this.customer_contact=this.customer_customerPhone;

        }
        localStorage.setItem('customer_contact',this.customer_contact);
        this.userperms = response.customer_details.cus_permission.split(',');

        console.log(this.userperms)
        for (var i = 0; i < this.userperms.length; i++) {

          this.pn.push(btoa(this.userperms[i]))

        }

        if (response.customer_details.dc_ip_menu > 0) {
          this.show_allowed_my_ip = true;
        } else {
          this.show_allowed_my_ip = false;
        }

        localStorage.setItem('pn', this.pn);
        localStorage.setItem('dept', response.customer_details.cms_default_department);
        localStorage.setItem('dept_name', response.customer_details.cms_department_name);

        for (var i = 0; i < this.userperms.length; i++) {

          if (this.userperms[i] == '101')
            this.serverService.invoice = 1;
          if (this.userperms[i] == '102') {
            this.serverService.prepaidnote = 1;
            this.serverService.creditnote = 1;
          }
          if (this.userperms[i] == '103')
            this.serverService.license = 1;
          if (this.userperms[i] == '104')
            this.serverService.projects = 1;
          if (this.userperms[i] == '105')
            this.serverService.phones = 1;
          if (this.userperms[i] == '107')
            this.serverService.leads = 1;
          if (this.userperms[i] == '131')
            this.serverService.reseller = 1;
          if (this.userperms[i] == '109')
            this.serverService.callhistory = 1;
          if (this.userperms[i] == '118')
            this.serverService.cxbuy = 1;
          if (this.userperms[i] == '134')
            this.serverService.iddpricelist = 1;
          if (this.userperms[i] == '138')
            this.serverService.call4tellicense = 1;
          if (this.userperms[i] == '157')
            this.serverService.supportticket = 1;
          if (this.userperms[i] == '110')
            this.serverService.users = 1;
          if (this.userperms[i] == '158')
            this.serverService.licencerenewal = 1;
          if (this.userperms[i] == '159')
            this.serverService.dealregistration = 1;
          if (this.userperms[i] == '160')
            this.serverService.gccfirewall = 1;
        }
        console.log(this.serverService.invoice)
        console.log(this.serverService.users)
        console.log(this.serverService.leads)
        console.log(this.serverService.license)

      }
      else {

      }
    },
      (error) => {
        console.log(error);
      });

  }

  notifyshown() {
    $('#notifymodal').modal('show');

    // this.notificationlist()


  }
  notificationlist() {

    // Swal.fire('Loading')
    // Swal.showLoading()
    let datas: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');


    datas.action = "notification_list";
    datas.customer_id = customer_id;


    datasend.access_token = access_token;
    datasend.operation = "curlDatas";
    datasend.moduleType = "notification";
    datasend.api_type = "web";
    datasend.element_data = datas;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      console.log(response)
      if (response.status == "true") {
        Swal.close()
        this.headernoti_count = response.count;
        this.notifydata = response.list;
        for (var i = 0; i < this.notifydata.length; i++) {
          if (this.notifydata[i].type == "referral")
            this.notifydata[i].image = "assets/img/notification/referral.png"
          if (this.notifydata[i].type == "payment_add")
            this.notifydata[i].image = "assets/img/notification/payment_add.png"
          if (this.notifydata[i].type == "renewal")
            this.notifydata[i].image = "assets/img/notification/renewal.png"
          if (this.notifydata[i].type == "invoice")
            this.notifydata[i].image = "assets/img/notification/invoice.png"
          if (this.notifydata[i].type == "payment_made")
            this.notifydata[i].image = "assets/img/notification/payment_made.png"
          if (this.notifydata[i].type == "support")
            this.notifydata[i].image = "assets/img/notification/support.png"
        }
      }
      else {
        Swal.close()
        this.notifydata = [];

      }

    },
      (error) => {
        console.log(error);
      });

  }

  updatenotify(val) {
    Swal.fire('Opening')
    Swal.showLoading()
    let data: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');
    datasend.access_token = access_token;


    data.action = "notification_update";
    data.customer_id = customer_id;
    data.id = val.id;

    datasend.operation = "curlDatas";
    datasend.moduleType = "notification";
    datasend.api_type = "web";
    datasend.element_data = data;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      console.log(response)
      if (response.status == "true") {
        Swal.close()
        $('#notifymodal').modal('hide');
        this.reads(val)
      }
      else {
        Swal.close()
        this.reads(val)
      }
    },
      (error) => {
        console.log(error);
      });

  }

  // createticket() {
  //   let api_reqs: any = '{"type": "create_ticket"}';
  //     this.serverService.popup.next(api_reqs);
  // }


  createticket(data) {
    // let api_reqs:any = '{"type": "profile"}';
    // this.serverService.emailcount.next(api_reqs);
    this.files = [];
    this.filesend = [];
    this.file = null;
    // this.createinformation.reset();
    tinymce.get('richTextAreacreated').setContent('');
    // $('#sales_r').val('');
    this.createinformation.get('messages').setValue(null);
    this.createinformation.get('subject').setValue(null);
    this.createinformation.get('country').setValue(null);
    this.createinformation.get('priority').setValue(null);
    this.createinformation.get('requestType').setValue(null);

    if(data != 'create_ticket'){
      $('#addNewPopup').modal('show');
    }

  }

  finishFunction() {
    // console.log(this.idmessage)
    // console.log($('#idmessage').val())
    // console.log(this.value)

    console.log(this.createinformation.value)
    if (this.createinformation.valid) {

      this.createnewticket()
      
    }
    else {

      this.validateAllFields(this.createinformation);
    }
  }
  validateAllFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFields(control);
      }
    });
  }

  createnewticket() {

    // consoless.log(atob(this.createinformation.value.messages))


    Swal.fire('Please wait')
    Swal.showLoading()
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');
    let cms_login_email =  localStorage.getItem('cms_login_email');
    var department_id = '103';
    // var department_id = localStorage.getItem('dept');
    const forms = new FormData();
    var msg_id = tinymce.get('richTextAreacreated').getContent();
    forms.append('name', this.customerdetails.customerName);
    // forms.append('email', this.datadetails.email_id);
    forms.append('email', cms_login_email);
    forms.append('customer_contact', this.customer_contact);
    forms.append('dept_id', department_id);
    forms.append('country_id', this.createinformation.value.country);
    forms.append('priority_id', this.createinformation.value.priority);
    forms.append('typeid', this.createinformation.value.requestType);
    forms.append('subject', this.createinformation.value.subject);
    // forms.append('message', this.createinformation.value.messages.replace(/<(?:.|\n)*?>/gm, ' '));
    forms.append('message', msg_id);
    // forms.append('custs_id',  this.datadetails.customer_id);
    forms.append('custs_id', customer_id);
    forms.append('custs_code', this.customerdetails.customerCode);

    for (var i = 0; i < this.filesend.length; i++) {
      forms.append('attachment[' + i + ']', this.filesend[i]);
    }

console.log(cms_login_email)
    // forms.append('attachment', this.file);
    // forms.append('action_info', 'add_ticket');
    // forms.append('action', 'create_ticket');
    // forms.append('operation', 'curlData');
    // forms.append('access_token', access_token);
    // forms.append('moduleType', 'login');
    // forms.append('api_type', 'web');


    forms.append('action', 'cms_create_ticket');
    forms.append('access_token', access_token);
    forms.append('api_type', 'web');

    console.log(forms); 
    var self = this;
    $.ajax({
      url: "https://erp.cal4care.com/cms_new/api_cms/v1.0/index_new.php",
      type: 'POST',
      data: forms,
      processData: false,  // tell jQuery not to process the data
      contentType: false,
      success: function (data) {
        console.log(data)

        // self.open_ticket({})
        // self.newticket({})
        // self.close_ticket({})
        // self.ticket_count()
        $('#addNewPopup').modal('hide');
        Swal.close();
        iziToast.success({
          message: "Ticket Created Successfully",
          position: 'topRight'
        });
        self.serverService.ticketRefresh.next();
        console.log("Hello from setTimeout");
        setTimeout(() => {
          let api_reqs:any = '{"type": "makeTicketCount"}';
        self.serverService.emailcount.next(api_reqs);
        }, 2000);
        

      }
    });







  }


  countryflag1() {

    let data: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');


    data.action = "customer_data";
    data.customer_id = customer_id;

    datasend.access_token = access_token;
    datasend.operation = "curlDatas";
    datasend.moduleType = "login";
    datasend.api_type = "web";
    datasend.element_data = data;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      console.log(response)
      if (response.status == "true") {
        this.customerdetails = response.customer_data;
        this.datadetails = response;
        this.createinformation.patchValue({

          fromticket: this.customerdetails.customerName,
          //department:"Support_SG"
          department: localStorage.getItem('dept_name')

        });
      }
      else {

      }
    },
      (error) => {
        console.log(error);
      });

  }
  jiraDropdown() {

    let data: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');


    data.action = "omni_dropdown";
    data.customer_id = customer_id;

    datasend.access_token = access_token;
    datasend.operation = "omniCurl";
    datasend.moduleType = "ticket";
    datasend.api_type = "web";
    datasend.element_data = data;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      console.log(response)
      if (response.status == "true") {

        this.countryList = response.country;
        this.priorityList = response.priority;
        this.supportRequestTypeList = response.type;

      }
      else {

      }
    },
      (error) => {
        console.log(error);
      });

  }
  localUrl;
  file: File;
  uploadFiless(event) {
    console.log(event[0])
    this.file = event[0];
    if (event[0] != undefined) {
      this.filesend.push(event[0])

    }

    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      this.files.push(element.name);
    }
    console.log(this.filesend)




  }



  uploadFile(event: any) {
    this.file = event.target.files[0];

    console.log(this.file)
    if (this.file != undefined) {

      this.filesend.push(this.file)
    }
    var events = event.target.files;
    for (let index = 0; index < events.length; index++) {
      const element = events[index];
      this.files.push(element.name)
    }

    console.log(this.filesend)

  }


  
  deleteAttachment(i) {
    this.files.splice(i, 1);
    this.filesend.splice(i, 1);
  }
  onMessageSend($event) {
    if ($event.keyCode != '') {

      // alert('1212')
      // this.sendChatMessageData();
      $event.stopPropagation();
      return false;
    }
  }


  initTiny() {
    var richTextArea_id = 'richTextAreacreated';
    tinymce.init({
      selector: '#richTextAreacreated',
      height: 500,
      plugins: 'advlist autolink textcolor formatpainter lists link  image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste  wordcount autolink lists media table',
      toolbar: 'undo redo |fullscreen|forecolor backcolor| formatselect | bold italic | \ undo redo | link image file| code | \
       alignleft aligncenter alignright alignjustify | \
       bullist numlist outdent indent | autoresize',
      paste_data_images: true,
      images_upload_url: 'upload.php',
      automatic_uploads: false,
      default_link_target: "_blank",
      extended_valid_elements: "a[href|target=_blank]",
      link_assume_external_targets: true,
      images_upload_handler: function (blobInfo, success, failure) {
        var xhr, formData;

        xhr = new XMLHttpRequest();
        xhr.withCredentials = false;
        xhr.open('POST', 'upload.php');

        xhr.onload = function () {
          var json;

          if (xhr.status != 200) {
            failure('HTTP Error: ' + xhr.status);
            return;
          }

          json = JSON.parse(xhr.responseText);

          if (!json || typeof json.file_path != 'string') {
            failure('Invalid JSON: ' + xhr.responseText);
            return;
          }

          success(json.file_path);
        };

        formData = new FormData();
        formData.append('file', blobInfo.blob(), blobInfo.filename());

        xhr.send(formData);
      },
    });
    if (tinymce.editors.length > 0) {
      //  tinymce.execCommand('mceFocus', true, richTextArea_id );       
      tinymce.execCommand('mceRemoveEditor', true, richTextArea_id);
      tinymce.execCommand('mceAddEditor', true, richTextArea_id);
    }
  }






}
